// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__3AHB9","loader__icon":"Loader_loader__icon__q1k9e","loader__text":"Loader_loader__text__hdeA3"};